// Keeps the header basket total in sync with the cart.
// cart-icon.js only refreshes the bubble count, so the money value needs its own listener.
const CURRENCY = document.documentElement.dataset.ceCurrency || 'GBP';
const LOCALE = document.documentElement.lang || 'en-GB';

const format = (cents) =>
  new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format((cents || 0) / 100);

const paint = (cents) => {
  document.querySelectorAll('[data-ce-cart-total]').forEach((el) => {
    el.textContent = format(cents);
  });
};

const refresh = async () => {
  try {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return;
    const cart = await res.json();
    paint(cart.total_price);
  } catch (error) {
    // leave the server-rendered value in place
  }
};

document.addEventListener('shopify:cart:lines-update', (event) => {
  const promise = /** @type {any} */ (event).promise;
  if (promise?.then) {
    promise
      .then(({ cart }) => {
        const total = cart?.cost?.totalAmount?.amount;
        if (total != null) paint(Math.round(Number(total) * 100));
        else refresh();
      })
      .catch(() => refresh());
  } else {
    refresh();
  }
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) refresh();
});
